<script setup>
import { computed, inject } from 'vue';
import { languages } from '@/config/languages';
import { useI18n } from 'vue-i18n';
import { useFetchData } from '@/composables/use-fetchData';

const { locale } = useI18n();
const backendApi = inject('backendApi');

const { loadData } = useFetchData(
    backendApi().auth().updateUserUIConfig,
    'userdata'
);

const enabledLanguages = computed(() => {
    return languages.filter((language) => language.enable);
});

const changeLocale = (localeCode) => {
    locale.value = localeCode;
    localStorage.setItem('locale', localeCode);

    loadData({
        uiconfig: {
            language: localeCode
        }
    });
};
</script>

<template>
    <div class="languages-container">
        <v-menu>
            <template v-slot:activator="{ props }">
                <v-btn color="white" dark v-bind="props">
                    {{ $i18n.locale }}
                </v-btn>
            </template>

            <v-list>
                <v-list-item
                    v-for="(language, index) in enabledLanguages"
                    :key="index"
                    :class="`li-locale-${language.code}`"
                    @click="changeLocale(language.code)"
                    :active="$i18n.locale === language.code"
                >
                    <v-list-item-title>{{ language.label }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>
